const testimonials = [
    {
        id: 1,
        quote: " Fydo helped us beat the local competition",
        description:
            "There are many stores around us selling the same items, and it was tough to stand out. But after we started using Fydo, things changed. The loyalty rewards gave us an edge customers started choosing our shop over others because they felt more valued here",
        author: "Samarjit Sahoo",
        rating: 4.9,
        authorStoreName: "Galaxy General Store ",
        authorStoreType: "Retail & Grocery Store",
        authorAvatar: "/images/avatar.png",
    },
    {
        id: 2,
        quote: "Now our connection with customers goes beyond the counter.",
        description:
            "We now connect with our customers beyond the shop. Fydo’s personalized offers and rewards have made our engagement more meaningful and effective.",
        author: "Avinash Nayak",
        rating: 4.8,
        authorStoreName: "Golden Bakery",
        authorStoreType: "Bakery Store",
        authorAvatar: "/images/avatar.png",
    },
    {
        id: 3,
        quote: "People keep coming back that’s the difference Fydo made.",
        description:
            "Fydo has helped us turn first time buyers into loyal customers. The loyalty program keeps people coming back, and we’ve seen a good increase in repeat visits.",
        author: " Patitapabana Aluk",
        rating: 4.8,
        authorStoreName: "Maa Dakhineswari Variety Store",
        authorStoreType: "Retail & Grocery Store",
        authorAvatar: "/images/avatar.png",
    },
    {
        id: 4,
        quote: "More walk-ins, more visibility all thanks to Fydo.",
        description:
            "Since onboarding with Fydo, we’ve noticed more new customers walking in thanks to the app’s discovery feature and local campaigns",
        author: "Pathani Pradhan",
        rating: 4.8,
        authorStoreName: "Tara Tarini Glass & Plywood",
        authorStoreType: "Hardware Store",
        authorAvatar: "/images/avatar.png",
    },
    {
        id: 5,
        quote: "It’s so easy and it actually works!",
        description:
            "The platform is so easy to use. Without spending extra on advertising, we’re able to reward loyalty and grow our regular customer base.",
        author: "Md. Irshad Ansari",
        rating: 4.8,
        authorStoreName: "Irshad Variety Store",
        authorStoreType: "Retail & Grocery Store",
        authorAvatar: "/images/avatar.png",
    },
    {
        id: 6,
        quote: "Loyalty with real results not just discounts.",
        description:
            "Fydo has added real value to our business. With its smart loyalty system, we've seen a rise in repeat customers and quicker conversions. It’s not just about offers it’s about building lasting relationships, and Fydo makes that easy and effective.",
        author: "Sohel",
        rating: 4.8,
        authorStoreName: "Big byte",
        authorStoreType: "Food & Dining",
        authorAvatar: "/images/avatar.png",
    },
    {
        id: 7,
        quote: "This is how loyalty should be done.",
        description:
            "Fydo has transformed how we connect with our customers. The loyalty features helped us not only retain our existing buyers but also attract new footfall. It’s simple, effective, and has definitely boosted our sales and brand presence.",
        author: "Monika Mohapatra",
        rating: 4.8,
        authorStoreName: "BLUEBERRY",
        authorStoreType: "Food & Dining",
        authorAvatar: "/images/avatar.png",
    },
    {
        id: 8,
        quote: "People now come for more than just food",
        description:
            "Since we started using Fydo, our repeat customers have significantly increased. The loyalty program encourages diners to come back, and the exclusive offers help us stand out in a competitive market. It's been a valuable addition to our restaurant’s growth strategy.",
        author: "Gourav Mohapatra",
        rating: 4.8,
        authorStoreName: "Delicacies On Plate",
        authorStoreType: "Food & Dining",
        authorAvatar: "/images/avatar.png",
    },
    {
        id: 9,
        quote: "Even in healthcare, loyalty matters and Fydo gets it.",
        description:
            "Fydo has helped us strengthen patient relationships through their smart loyalty features. Regular clients now feel more valued, and referrals have grown through word of mouth. It's a unique tool for a diagnostic lab like ours, adding a human touch to healthcare services.",
        author: "Gopal Krushna Mohapatra",
        rating: 4.8,
        authorStoreName: "Vijaya Clinical Laboratory",
        authorStoreType: "Doctor Laboratory",
        authorAvatar: "/images/avatar.png",
    },
    {
        id: 10,
        quote: "Old customers returned, and new ones followed.",
        description:
            "With Fydo, we've seen a noticeable increase in repeat visits and customer engagement. The loyalty program not only brings back our old customers but also encourages them to refer others. It’s been a game changer for our optical business.",
        author: "SK Sakil",
        rating: 4.8,
        authorStoreName: "Netra Vision",
        authorStoreType: "Optical Store",
        authorAvatar: "/images/avatar.png",
    },
    {
        id: 11,
        quote: " Fydo showed us what our customers really want.",
        description:
            "Getting feedback and insights through Fydo has helped us improve service and offer exactly what our customers want.",
        author: "Shreejit Panda",
        rating: 4.8,
        authorStoreName: "Biggies Burger ",
        authorStoreType: "Food & Dining",
        authorAvatar: "/images/avatar.png",
    },
];



export default testimonials;